import React from 'react';
import ReactDOM from 'react-dom/client';
import packageJson from '../package.json';
import './index.less';
import './components/registerNestedDrawers';
import { Provider } from 'react-redux';
// @ts-ignore
import * as Sentry from '@sentry/react';
import { store, persistor } from './redux/config';
import AppRoute from './routes/AppRoute';
import { PersistGate } from 'redux-persist/integration/react';
import LoadingIcon from './components/shared/LoadingIcon';
import { ConfigProvider } from 'antd';

Sentry.init({
  dsn: process.env.VITE_SENTRY_DSN,
  // Enable Browser Tracing to capture page loads, navigations, and API calls
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.3, // adjust per env if needed
  tracePropagationTargets: [process.env.VITE_API_URL as string],
  release: packageJson.version,
  environment:
    process.env.VITE_STAGE === 'production' ? 'production' : 'staging',
  // Ignore errors typically caused by browser extensions (Grammarly, Google Translate, etc.)
  ignoreErrors: [
    /Failed to execute 'insertBefore' on 'Node'/,
    /Failed to execute 'removeChild' on 'Node'/,
    /The node before which the new node is to be inserted is not a child of this node/,
    /The node to be removed is not a child of this node/,
  ],
});

let root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.Fragment>
    <Provider store={store}>
      <PersistGate loading={<LoadingIcon />} persistor={persistor}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#0077be',
              fontSize: 15,
            },
            components: {
              Button: {},
              Table: {
                rowHoverBg: 'rgba(216, 245, 35, 0.1)',
                rowSelectedBg: 'unset',
                rowSelectedHoverBg: 'unset',
              },
              Select: {
                optionSelectedColor: '#000',
              },
            },
          }}
        >
          <AppRoute />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </React.Fragment>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
